import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImageFigureSection, ImageFigureComponent } from '../image-figure/image-figure.component';
import { VideoFigureSection, VideoFigureComponent } from '../video-figure/video-figure.component';
import { InnerSectionComponent } from '../inner-section/inner-section.component';
import { ColumnWidth } from '@knorr-bremse-portals/ngx-components';

export type VisualFigureSection = ImageFigureSection | VideoFigureSection;

@Component({
    selector: 'app-visual-figure',
    imports: [VideoFigureComponent, ImageFigureComponent],
    templateUrl: './visual-figure.component.html',
    styleUrl: './visual-figure.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisualFigureComponent extends InnerSectionComponent<VisualFigureSection> {

  public rootColumns = input.required<ColumnWidth>()

}
